import React from 'react';
import { motion } from 'framer-motion';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'outline' | 'ghost';
  isLoading?: boolean;
  fullWidth?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  isLoading = false,
  fullWidth = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-3 text-base font-medium transition-all duration-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#D4AF37] disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-[#D4AF37] text-white hover:bg-[#C9A961] shadow-lg hover:shadow-[#D4AF37]/30',
    outline: 'border-2 border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37] hover:text-white',
    ghost: 'text-white hover:text-[#D4AF37] hover:bg-white/5'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`
        ${baseStyles}
        ${variants[variant]}
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} disabled={isLoading || props.disabled} {...props} data-id="element-6">
      {isLoading ? <>
          <Loader2 className="w-4 h-4 mr-2 animate-spin" data-id="element-7" />
          Loading...
        </> : children}
    </motion.button>;
}